import { render, staticRenderFns } from "./RevStatusCpt.vue?vue&type=template&id=e8f82c4e&"
import script from "./RevStatusCpt.vue?vue&type=script&lang=ts&"
export * from "./RevStatusCpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports